import { ReactNode } from "react";

import { Note } from "@phosphor-icons/react";
import { Label } from "@reactive-resume/ui";

import { useCoverLetterStore } from "@/client/stores/cover-letter";
import { CLCollapsibleSection } from "../../../CollapsibleSection";

export const CLNotesSection = () => {
  const setValue = useCoverLetterStore((state) => state.setValue);
  const notes = useCoverLetterStore((state) => state.coverLetter.data.metadata.notes);

  const headerHTML: ReactNode = (
    <div className="flex items-center gap-x-4">
      <Note size={18} />
      <h2 className="line-clamp-1 text-base font-bold text-gray-800 lg:text-lg">Notes</h2>
    </div>
  );

  const contentHTML: ReactNode = (
    <main className="space-y-1.5">
      <Label>Personal Notes</Label>
      <p className="text-xs text-muted-foreground">
        These notes are for your reference only and will not appear in the cover letter.
      </p>
      <textarea
        rows={5}
        className="w-full rounded-md border bg-white p-3 text-sm"
        value={notes}
        onChange={(event) => setValue("metadata.notes", event.target.value)}
      />
    </main>
  );

  return <CLCollapsibleSection id="cl-notes" header={headerHTML} content={contentHTML} />;
};
